var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/visual-character-counter.tsx";
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { length } from 'stringz';
import ProgressCircle from 'soapbox/components/progress-circle';
const messages = defineMessages({
  title: {
    "id": "compose.character_counter.title",
    "defaultMessage": "Used {chars} out of {maxChars} characters"
  }
});

/** Renders a character counter */
const VisualCharacterCounter = _ref => {
  let {
    text,
    max
  } = _ref;
  const intl = useIntl();
  const textLength = length(text);
  const progress = textLength / max;
  return /*#__PURE__*/React.createElement(ProgressCircle, {
    title: intl.formatMessage(messages.title, {
      chars: textLength,
      maxChars: max
    }),
    progress: progress,
    radius: 10,
    stroke: 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  });
};

export default VisualCharacterCounter;